module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'noData': !_vm.hasData && !_vm.isLoading
    },
    attrs: {
      "id": "striiv-pulse-line-graph"
    }
  }, [_c('div', {
    staticClass: "loadingStatus"
  }, [(_vm.isLoading) ? _c('mu-circular-progress', {
    staticClass: "noDataStatus",
    attrs: {
      "size": 60,
      "align": "center",
      "color": "#F75039"
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.isLoading && _vm.hasData) ? _c('line-chart', {
    attrs: {
      "width": "1500",
      "data": _vm.chartData,
      "options": _vm.chartOptions,
      "height": _vm.computedHeight
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.hasData && !_vm.isLoading) ? _c('div', {
    staticClass: "noDataStatus"
  }, [_c('alert', {
    attrs: {
      "type": "info",
      "icon": "info",
      "align": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n        Not enough data to create a chart\n      ")])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f096700","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Graphs/Pulse/LineGraph.vue
// module id = 3627
// module chunks = 1